import React from "react";
import { useTranslation } from "react-i18next";

import { useListEdition } from "@planzone/view-models";
import { Props } from "./types";
import { NameForm } from "./nameForm";
import { RichTextInput } from "@common/richTextInput";
import styles from "./styles.scss";

function Details({ list, error, readOnly }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, editList } = useListEdition();
  const [description, setDescription] = React.useState(list.description);
  const [isEditable, setIsEditable] = React.useState(false);
  const toggleTitleModification = () => setIsEditable(!isEditable);

  React.useEffect(() => {
    setDescription(list.description);
  }, [list]);

  return (
    <div className={styles.details}>
      {!readOnly && isEditable ? (
        <NameForm
          list={list}
          isInvalid={error.emptyName || error.duplicateName}
          hide={toggleTitleModification}
        />
      ) : (
        <h1 className={styles.name} onClick={toggleTitleModification}>
          {list.name}
        </h1>
      )}
      <div className={styles.description}>
        <h3 className={styles.label}>{t("listRetrieval.description")}</h3>
        <RichTextInput
          value={description || ""}
          maxLength={10000}
          placeholder={t("listRetrieval.description")}
          input={setDescription}
          onChange={() =>
            !isRequestPending &&
            editList({
              list,
              nextList: { ...list, description },
            })
          }
          isDisabled={readOnly}
        />
      </div>
    </div>
  );
}

export { Details };
